import qwest from 'qwest';

import User from '../models/user.jsx';

import events from '../lib/events.js';

let onSuccess = (type) => {
  if (type === 'list') {
    return (xhr, response) => {
      if (response.success) {
        return response.data.map(x => User.fromApiFormat(x));
      }
      throw response;
    };
  }
  return (xhr, response) => {
    if (response.success) {
      return User.fromApiFormat(response.data);
    }
    throw response;
  };
};

let onError = () => {
  throw {
    code: -1,
    data: null,
    message: 'Unexpected Error',
    success: false,
  };
};

let userApi = {
  getUser(id) {
    return qwest.get(`/User?id=${id}`)
      .then(onSuccess('single'), onError);
  },

  getUsers() {
    return qwest.get('/User/All')
      .then(onSuccess('list'), onError);
  },

  deleteUser(user) {
    return qwest.delete('/User', user.toApiFormat())
      .then(onSuccess('single'), onError);
  },

  updateInfo(user) {
    return qwest.post('/User/UpdateInfo', user);
  },

  loginUnique(key, user, check = 2) {
    return new Promise((resolve, reject) => {
      qwest.get(`/User/LoginUnique?email=${user.email}&username=${user.username}&check=${check}`)
        .then((xhr, response) => {
          if (response.success) {
            events.publish('cancel.error', {
              key: key + 'uniqueEmailUsername',
            });
            resolve(200);
          } else {
            if (response.code === 472 || response.code === 473 || response.code === 474) {
              events.publish('cancel.error', {
                key: key + 'uniqueEmailUsername',
              });
              events.publish('error.user', {
                message: response.message,
                key: key + 'uniqueEmailUsername',
              });
            }
            resolve(response.code);
          }
        })
        .catch(response => reject(response));
    });
  },

  saveUser(key, user, password, confirm) {
    return new Promise((resolve, reject) => {
      let address = '/User';

      if (password && confirm) {
        address += `?password=${password}&confirm=${confirm}`;
      }
      qwest.post(address, user.toApiFormat())
        .then((xhr, response) => {
          if (response.success) {
            let user = User.fromApiFormat(response.data);

            events.publish('cancel.error', {
              key: key + 'uniqueEmailUsername',
            });
            resolve(user);
          } else {
            if (response.code === 472 || response.code === 473 || response.code === 474) {
              events.publish('cancel.error', {
                key: key + 'uniqueEmailUsername',
              });
              events.publish('error.user', {
                message: response.message,
                key: key + 'uniqueEmailUsername',
              });
            }
            reject(response);
          }
        });
    });
  },
};

export default userApi;
